import { makeAutoObservable, runInAction } from 'mobx'
import { http } from '@/utils'

class DhspStore {

    //数据列表初始化
    dataList = [];

    //总条数
    total = '';

    //条数
    pagesize = 10;

    //当前页
    page = 1;

    //表单收集
    valueData = {}

    //弹框状态初始化
    isActive = false
    //弹框名字
    url = ''

    title=''
    constructor() {
        makeAutoObservable(this)
    }

    //数据获取
    getDataList = async () => {
        const res = await http.post(`/adminapi/haikangcam/index?page=${this.page}&pagesize=${this.pagesize}`)
        runInAction(() => {
            this.dataList = JSON.parse(JSON.stringify(res.data.data.list))
            this.total = res.data.data.total
        })
    }

    getCheckVideo =async ()=>{
        const res = await http.post(`/adminapi/haikangcam/look?camcode=${this.valueData.cameraIndexCode}`)
        // console.log(res.data.data,'45')
        runInAction(()=>{
            this.url=res.data.data.url
        })
    }

    //视频回放
    getPlayBack =async ()=>{
        const res = await http.post(`/adminapi/haikangcam/playback?camcode=${this.valueData.cameraIndexCode}`)
        // console.log(res.data,'111')
        // runInAction(()=>{
        //     this.url=res.data.data.url
        // })
    }

    onClickBtn =async (val,val2)=>{
        // console.log(val,val2,'c')
        const res = await http.post(`/adminapi/haikangcam/ptzsctl?camcode=${this.valueData.cameraIndexCode}&command=${val}&action=${val2}`)
        // console.log(res,'555')
    }
}

export { DhspStore }